<template>
    <oButton
        ref="accountMenu"
        :class="['opteo-sidebar-menu-link help-sidebar-menu', { active }]"
        color="white"
    >
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="#e0e0e5">
                <path
                    d="M16 31c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15ZM16 15v8"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="square"
                />
                <path
                    d="M17 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
                    fill="#e0e0e5"
                    class="help-i-icon-dot"
                />
            </g>
        </svg>
    </oButton>
</template>

<script lang="ts" setup>
import { oButton } from '@opteo/components-next'

defineProps<{
    active: boolean
}>()
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.help-sidebar-menu svg g {
    stroke: #ccccce;
    transition: all 0.25s cubic-bezier(0.19, 1, 0.22, 1);
}
.help-sidebar-menu.active svg g {
    stroke: $opteo-blue;
}

.help-sidebar-menu svg g .help-i-icon-dot {
    fill: #ccccce;
}
.help-sidebar-menu.active svg g .help-i-icon-dot {
    fill: $opteo-blue;
}
</style>
